import { module } from 'stereomodularjs'

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.numberEl = this.el.querySelector('.o-stats__number')
        this.number = this.el.querySelector('.o-stats__number').dataset.number
        this.number = parseFloat(this.number.replace(',', '.'))
        this.currentValue = 0 // Initialize current value
        this.speed = 120 // Match the CSS transition duration of o-stats__progress

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Element is in viewport
                    this.animateNumber()
                    observer.unobserve(this.numberEl) // Stop observing once element is in viewport
                }
            })
        }, {
            rootMargin: '0px 0px -25px 0px'
        })

        observer.observe(this.numberEl)
    }

    animateNumber() {
        let displayValue;
        const lang = document.documentElement.lang;
        const speed = this.speed; // Default speed is 60 frames per second
        const step = (this.number - this.currentValue) / speed;

        const updateValue = () => {
            this.currentValue += step;

            // Ensure the currentValue never exceeds the target
            if (this.currentValue > this.number) {
                this.currentValue = this.number;
            }

            const hasDecimals = this.number % 1 !== 0;
            const decimalPlaces = hasDecimals ? this.number.toString().split('.')[1].length : 0;

            if (lang === 'fr-CA') {
                displayValue = this.currentValue.toLocaleString('fr-FR', {
                    minimumFractionDigits: decimalPlaces,
                    maximumFractionDigits: decimalPlaces
                });
            } else {
                displayValue = this.currentValue.toLocaleString('en-US', {
                    minimumFractionDigits: decimalPlaces,
                    maximumFractionDigits: decimalPlaces
                });
            }

            this.numberEl.innerHTML = displayValue;

            if (this.currentValue < this.number) {
                requestAnimationFrame(updateValue);
            }
        };

        updateValue();
    }


    destroy() {
        // Remove event listeners
        window.removeEventListener('animateNumber')
    }
}
